/** Barra de pasos de los formularios del Brain (cliente nuevo, perfil PML): número, tilde al completar, etiqueta. */
export function StepBar({ current, labels }: { current: number; labels: string[] }) {
  return (
    <div className="flex items-center gap-1 mb-8">
      {labels.map((label, i) => (
        <div key={i} className="flex items-center gap-1">
          <div
            className={`flex items-center justify-center w-7 h-7 rounded-full text-xs font-semibold transition-colors ${
              i < current ? 'bg-emerald-500 text-white'
              : i === current ? 'bg-[#FF6B6B] text-white'
              : 'bg-gray-100 text-gray-400'
            }`}
          >
            {i < current ? '✓' : i + 1}
          </div>
          <span className={`text-xs hidden sm:inline ${i === current ? 'text-gray-900 font-medium' : 'text-gray-400'}`}>
            {label}
          </span>
          {i < labels.length - 1 && (
            <div className={`w-6 h-px mx-1 ${i < current ? 'bg-emerald-400' : 'bg-gray-200'}`} />
          )}
        </div>
      ))}
    </div>
  );
}
